module.exports = __webpack_public_path__ + "static/aime_email_badge-d2e8b707bd397bfa28228555818e9acb.png";